import clsx from 'clsx';
import React from 'react';

export default function Tab({
  tabs,
  setActiveTab,
  activeTab,
  className,
}: {
  tabs: { name: string; value: any }[];
  setActiveTab: (name: any) => void;
  activeTab: string;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'flex text-lg font-semibold text-primary gap-6 overflow-hidden',
        className,
      )}
    >
      {tabs.map(tab => {
        return (
          <div key={tab.name} onClick={() => setActiveTab(tab.value)}>
            <button
              className={clsx(activeTab !== tab.value && 'text-secondary')}
            >
              {tab.name}
            </button>
          </div>
        );
      })}
    </div>
  );
}
